import { getCatalogFacetedCategoriesArgsToParams } from 'data/api/transformers/arguments/get-catalog-faceted-categories-args-to-params'
import { GetCatalogFacetedCategoriesArgs } from 'types/api/arguments/get-catalog-faceted-categories-args'
import { GetCatalogFacetedCategoriesResp } from 'types/api/response/get-catalog-faceted-categories-resp'

import { api } from './api'

export const getCatalogFacetedCategories = (args: GetCatalogFacetedCategoriesArgs) =>
  api.get<GetCatalogFacetedCategoriesResp>('/catalog/faceted_categories', {
    params: getCatalogFacetedCategoriesArgsToParams(args),
  })
